import { Injectable } from '@angular/core';
import { environment } from 'app/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ViaCepService {
  constructor(private http: HttpClient) {}

  findByCep(cep: string | number) {
    return this.http.get(`${environment.apiViaCep}/${cep}/json`);
  }

  findRaw(state: string, city: string, logradouro: string) {
    return this.http.get(
      `${environment.apiViaCep}/${state}/${city}/${logradouro}/json`
    );
  }
}
